module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_shifuku-b0675cb0583611e12b137a2cf720f158.jpg";